export const B2bClientListItem = (json: IB2bClientDto): IB2bClientListItemModel => {
	const { welcome_bonus_starts_at, welcome_bonus_ends_at, created_at, updated_at, ...rest } = json

	return {
		...toCamelCase(rest),
		welcomeBonusStartsAt: welcome_bonus_starts_at ? new Date(welcome_bonus_starts_at) : null,
		welcomeBonusEndsAt: welcome_bonus_ends_at ? new Date(welcome_bonus_ends_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const B2bClientCreatePayload = (form: IB2bClientFormData): IB2bClientCreatePayload => {
	const { welcomeBonusStartsAt, welcomeBonusEndsAt, welcomeBonusAmount, ...rest } = form

	return {
		...toSnakeCase(rest),
		welcome_bonus_amount: PriceToCents(welcomeBonusAmount),
		welcome_bonus_starts_at: welcomeBonusStartsAt ? welcomeBonusStartsAt.toISOString() : null,
		welcome_bonus_ends_at: welcomeBonusEndsAt ? welcomeBonusEndsAt.toISOString() : null,
	}
}

export const B2bClientUpdatePayload = (form: IB2bClientFormData): IB2bClientUpdatePayload => ({
	...B2bClientCreatePayload(form),
})

export const B2bClientUser = (json: IB2bClientRegistrationSnapshotDto): IB2bClientUserModel => {
	const { registered, ...rest } = json

	return {
		...toCamelCase(rest),
		registeredAt: registered ? new Date(registered) : null,
	}
}
